import { Menu, Transition } from "@headlessui/react";
import React, { FC } from "react";
import { cn } from "src/utils/utils";

interface DropdownProps {
  placeholder: string;
  icon?: string;
  menuItems: any[];
  displayKey: string;
  onOptionClick: any;
  currentSelected: string | number | undefined;
  hierarchyDisplay?: string;
  buttonImage?: any;
  imageClassName?: any;
}

const Dropdown: FC<DropdownProps> = ({
  placeholder,
  icon,
  menuItems,
  displayKey,
  hierarchyDisplay,
  onOptionClick,
  buttonImage = null,
  currentSelected,
  imageClassName,
}) => {
  return (
    <Menu as="div" className="relative inline-block w-full text-left">
      <Menu.Button
        className={cn(
          `${
            imageClassName
              ? imageClassName
              : "inline-flex items-center justify-center w-full gap-2 px-4 py-2 text-sm font-semibold text-black capitalize bg-white border rounded-md hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
          }`,
        )}
      >
        {!buttonImage && <p className="whitespace-nowrap text-[#49484C] text-sm font-medium"> {currentSelected || placeholder}</p>}
        {buttonImage && <img src={buttonImage} width={20} height={20} alt="menu_image" />}
        {icon && <img className="w-4 h-4" src={icon} alt="down arrow" />}
      </Menu.Button>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-20 w-auto min-w-full mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {menuItems.map((menuItem) => (
            <div key={menuItem[displayKey]} className="px-1 text-left text-[#1E1E1E] text-sm font-normal w-full py-1">
              <Menu.Item>
                {() => (
                  <button onClick={() => onOptionClick(menuItem)} className="py-2 capitalize cursor-pointer hover:text-purple-400">
                    {hierarchyDisplay ? menuItem[displayKey][hierarchyDisplay] : menuItem[displayKey]}
                  </button>
                )}
              </Menu.Item>
            </div>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default Dropdown;
